<!--suppress EqualityComparisonWithCoercionJS -->
<template>
    <div>
        <ul class="nav nav-pills" id="customize_tab" :class="{'d-none':this.hideTabList}" role="tablist">

            <li v-if="hasPropertyGroupActive(configuration.groupIdBranding)" class="nav-item">
                <a @click="value.selectedGroupId = configuration.groupIdBranding"
                   class="nav-link" id="productTab" data-toggle="tab" href="#product" role="tab"
                   aria-controls="profile" aria-selected="false">{{ "ShoppingWizard::Template.brandingProduct" |
                    translate }}</a>
            </li>

            <li v-if="hasPropertyGroupActive(configuration.groupIdAirbrush)" class="nav-item">
                <a @click="value.selectedGroupId = configuration.groupIdAirbrush"
                   class="nav-link" id="airbrushTab" data-toggle="tab" href="#airbrush" role="tab"
                   ref="airbrushTab"
                   aria-controls="contact" aria-selected="false">{{ "ShoppingWizard::Template.motive" | translate }}</a>
            </li>
        </ul>
        <div class="tab-content" id="customize_tab_content">

            <!-- Front -->
            <div v-if="hasPropertyGroupActive(configuration.groupIdBranding)" class="tab-pane fade show active"
                 id="product" role="tabpanel"
                 aria-labelledby="profile-tab">

                <div class="mt-1 property-container">
                    <h3 class="mt-0 mb-3">
                        <template v-if="hasBrandingPosition('tag') || hasBrandingPosition('tagBlack')">
                            {{ "ShoppingWizard::Template.titleTag" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('griffRT') || hasBrandingPosition('griffRTBlack')">
                            {{ "ShoppingWizard::Template.titleGriffRT" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('flap')">
                            {{ "ShoppingWizard::Template.titleFlap" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('front')">
                            {{ "ShoppingWizard::Template.titleFront" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('back')">
                            {{ "ShoppingWizard::Template.titleBack" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('cornerRightBottom')">
                            {{ "ShoppingWizard::Template.titleCornerRightBottom" | translate }}
                        </template>
                    </h3>

                    <p>
                        <template v-if="hasBrandingPosition('tag') || hasBrandingPosition('tagBlack')">
                            {{ "ShoppingWizard::Template.descriptionTag" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('griffRT') || hasBrandingPosition('griffRTBlack')">
                            {{ "ShoppingWizard::Template.descriptionGriffRT" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('flap')">
                            {{ "ShoppingWizard::Template.descriptionFlap" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('front')">
                            {{ "ShoppingWizard::Template.descriptionFront" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('back')">
                            {{ "ShoppingWizard::Template.descriptionBack" | translate }}
                        </template>
                        <template v-if="hasBrandingPosition('cornerRightBottom')">
                            {{ "ShoppingWizard::Template.descriptionCornerRightBottom" | translate }}
                        </template>
                    </p>

                    <hr/>

                    <h5>
                        {{ "ShoppingWizard::Template.questionOfBrandingType" | translate }}
                    </h5>

                    <div class="branding row">
                        <div class="col-lg-4 mt-3"
                             v-if="hasProperty(configuration.productBranding.brandingTypeIdDefault)">

                            <shopping-wizard-selection-button
                                    v-model="value.selectedBrandingTypeId"
                                    :img-url="configuration.productBranding.imageMap.default"
                                    :property="getProperty(configuration.productBranding.brandingTypeIdDefault)"
                                    additional-class="default-branding">
                                {{ "ShoppingWizard::Template.brandingDefault" | translate }}
                            </shopping-wizard-selection-button>

                        </div>
                        <div class="col-lg-4 mt-3"
                             v-if="hasProperty(configuration.productBranding.brandingTypeIdSilver)">
                            <shopping-wizard-selection-button
                                    v-model="value.selectedBrandingTypeId"
                                    :img-url="configuration.productBranding.imageMap.silver"
                                    :property="getProperty(configuration.productBranding.brandingTypeIdSilver)"
                                    additional-class="silver-branding">
                                {{ "ShoppingWizard::Template.brandingSilver" | translate }}
                            </shopping-wizard-selection-button>
                        </div>
                        <div class="col-lg-4 mt-3" v-if="hasProperty(configuration.productBranding.brandingTypeIdGold)">
                            <shopping-wizard-selection-button
                                    v-model="value.selectedBrandingTypeId"
                                    :img-url="configuration.productBranding.imageMap.gold"
                                    :property="getProperty(configuration.productBranding.brandingTypeIdGold)"
                                    additional-class="gold-branding">
                                {{ "ShoppingWizard::Template.brandingGold" | translate }}
                            </shopping-wizard-selection-button>
                        </div>
                    </div>

                    <hr/>

                    <h5>{{ "ShoppingWizard::Template.putYourInitials" | translate }}</h5>
                    <input type="text"
                           class="form-control text-uppercase"
                           :class="{'is-invalid':validation.hasError}" maxlength="5"
                           placeholder="z.B. &quot;A.B&quot;" v-model="value.initials">
                    <span v-if="validation.hasError" class="text-danger d-block">
                        {{ this.validation.errorMessage | translate }}
                    </span>
                </div>
            </div>

            <!-- Airbrush -->
            <div v-if="hasPropertyGroupActive(configuration.groupIdAirbrush)" class="tab-pane row" id="airbrush"
                 role="tabpanel" aria-labelledby="contact-tab">

                <div class="mt-1 property-container">
                    <h3 class="mt-0 mb-3">{{ "ShoppingWizard::Template.motive" | translate }}</h3>
                    <p>{{ "ShoppingWizard::Template.motiveDescription" | translate }}</p>

                    <hr/>

                    <h5>
                        {{ "ShoppingWizard::Template.questionOfCustomization" | translate }}
                    </h5>

                    <div class="row">
                        <div class="col-lg-6 mt-3">

                            <shopping-wizard-selection-button
                                    v-if="hasProperty(configuration.airbrush.airbrushTypeIdMotive)"
                                    v-model="value.selectedAirbrushTypeId"
                                    :img-url="configuration.airbrush.imageMap.motives"
                                    :property="getProperty(configuration.airbrush.airbrushTypeIdMotive)"
                                    additional-class="airbrush-motive">
                                {{ "ShoppingWizard::Template.motive" | translate }}
                            </shopping-wizard-selection-button>

                        </div>
                        <div class="col-lg-6 mt-3" v-if="hasProperty(configuration.airbrush.airbrushTypeIdLetter)">

                            <shopping-wizard-selection-button
                                    v-model="value.selectedAirbrushTypeId"
                                    :property="getProperty(configuration.airbrush.airbrushTypeIdLetter)"
                                    :img-url="configuration.airbrush.imageMap.letters"
                                    additional-class="airbrush-letters">
                                {{ "ShoppingWizard::Template.letters" | translate }}
                            </shopping-wizard-selection-button>

                        </div>
                    </div>

                    <template
                            v-if="value.selectedAirbrushTypeId == configuration.airbrush.airbrushTypeIdMotive">
                        <hr/>
                        <h5 class="mb-2">{{ "ShoppingWizard::Template.motiveSelection" | translate }}</h5>

                        <div>
                            <a class="motive" v-for="propertySelection of motiveSelectionsList"
                               :class="{'active': value.selectedMotiveSelectionId == propertySelection.id}"
                               @click="value.selectedMotiveSelectionId = propertySelection.id"
                               :title="propertySelection.name">
                                <img :alt="propertySelection.name"
                                     :src="configuration.airbrush.imageMap.motivesPath+'/'+propertySelection.id+'.png'">
                            </a>
                        </div>

                        <div class="w-100">
                            <p class="text-right mt-3">
                                {{ "ShoppingWizard::Template.uniqueFirstLine" | translate }}<br>
                                {{ "ShoppingWizard::Template.uniqueSecondLine" | translate }}
                            </p>
                            <a class="btn btn-default float-right" :href="configuration.airbrush.customOrderLink">
                                {{ "ShoppingWizard::Template.requestUnique" | translate }}
                            </a>
                            <div class="clearfix"></div>
                        </div>

                    </template>

                    <template
                            v-if="value.selectedAirbrushTypeId == configuration.airbrush.airbrushTypeIdLetter">
                        <hr/>
                        <h5>{{ "ShoppingWizard::Template.putYourInitials" | translate }}</h5>
                        <input type="text"
                               class="form-control text-uppercase"
                               :class="{'is-invalid':validation.hasError}" maxlength="5"
                               placeholder="z.B. &quot;A.B&quot;" v-model="value.initials">
                        <span v-if="validation.hasError" class="text-danger d-block">
                            {{ this.validation.errorMessage | translate }}
                        </span>
                    </template>

                    <template
                            v-if="hasProperty(configuration.airbrush.airbrushTypeIdColor)">
                        <hr/>
                        <h5 class="mb-2">{{ "ShoppingWizard::Template.colorSelection" | translate }}</h5>

                        <div>
                            <a class="colors" v-for="propertySelection of colorSelectionsList"
                               :class="{'active': value.selectedColorSelectionId == propertySelection.id}"
                               @click="value.selectedColorSelectionId = propertySelection.id"
                               :title="propertySelection.name">
                                <img :alt="propertySelection.name"
                                     :src="configuration.airbrush.imageMap.motivesPath+'/'+propertySelection.id+'.png'">
                            </a>
                        </div>
                    </template>

                </div>
            </div>


        </div>


    </div>
</template>

<script>

    export default {
        props: {
            properties: Array,
            configuration: Object,
            value: {
                selectedGroupId: Number,

                selectedBrandingTypeId: Number,
                initials: String,

                selectedAirbrushTypeId: Number,
                selectedMotiveSelectionId: Number,
                selectedColorSelectionId: Number,
            }
        },
        data() {
            return {
                shoppingWizardModal: {},
                additionalPrice: 0.00,


                motiveSelectionsList: [],
                colorSelectionsList: [],

                hideTabList: true,

                validation: {
                    hasError: false,
                    errorMessage: ''
                }

            }
        },
        mounted() {
            //console.log(this.properties);

            let counter = 0;
            let hasProductProperty = this.hasPropertyGroupActive(this.configuration.groupIdBranding);
            let hasAirbrushProperty = this.hasPropertyGroupActive(this.configuration.groupIdAirbrush);

            //console.debug('has product', hasProductProperty);
            if (hasProductProperty) {
                counter++;
            }
            if (hasAirbrushProperty) {
                counter++;
            }

            if (counter >= 2) {
                this.hideTabList = false;
            }

            if (!hasProductProperty) {
                this.$nextTick(() => {
                    $('#airbrushTab').tab('show');
                });
                this.value.selectedGroupId = this.configuration.groupIdAirbrush;
            }


            this.$emit('is-valid', false);

            if (hasAirbrushProperty) {
                let motiveSelectionProperty = this.getProperty(this.configuration.airbrush.airbrushTypeIdMotive);
                if (motiveSelectionProperty !== null) {
                    $.get('/rest/shopping-wizard/property/selection/' + motiveSelectionProperty.propertyId)
                        .done((response) => {
                            if (!response.error) {
                                this.motiveSelectionsList = response;
                            }
                        })
                        .fail((jqXHR) => {

                        })
                        .always(() => {
                            //loading
                        });
                }

                let colorSelectionProperty = this.getProperty(this.configuration.airbrush.airbrushTypeIdColor);
                if (colorSelectionProperty !== null) {
                    $.get('/rest/shopping-wizard/property/selection/' + colorSelectionProperty.propertyId)
                        .done((response) => {
                            if (!response.error) {
                                this.colorSelectionsList = response;
                            }
                        })
                        .fail((jqXHR) => {

                        })
                        .always(() => {
                            //loading
                        });
                }
            }
        },
        methods: {
            hasPropertyGroupActive(propertyGroupId) {
                for (let property of this.properties) {
                    if (property.group) {
                        if (property.group.id == propertyGroupId) {
                            return true;
                        }
                    }
                }
                return false;
            },
            hasBrandingPosition(positionKey) {

                let property = this.getProperty(this.configuration.productBranding.brandingPosition);
                if (property) {
                    return property.propertySelectionId == this.configuration.productBranding.positions[positionKey].selectionId;
                }
                return false;
            },
            getBrandingPositionKey() {

                let property = this.getProperty(this.configuration.productBranding.brandingPosition);
                if (property) {
                    for (let positionKey in this.configuration.productBranding.positions) {
                        if (property.propertySelectionId == this.configuration.productBranding.positions[positionKey].selectionId) {
                            return positionKey;
                        }
                    }
                }
                return null;
            },
            hasProperty(propertyId) {
                for (let property of this.properties) {
                    if (property.propertyId == propertyId) {
                        return true;
                    }
                }
                return false;
            },
            getProperty(propertyId) {
                for (let property of this.properties) {
                    if (property.propertyId == propertyId) {
                        return property;
                    }
                }
                return {};
            }
        },
        computed: {
            initials() {
                return this.value.initials;
            }
        },
        watch: {
            initials: function (val) {
                if (val.length === 0) {
                    this.validation.hasError = true;
                    this.validation.errorMessage = 'ShoppingWizard::Template.errorMessagePutInitials';
                } else {
                    let result = val.match(/^([a-zA-Z]){1,3}(\.([a-zA-Z]){0,2}\.?([a-zA-Z])?)?$/g);
                    let charCheck = val.match(/([a-zA-Z])/g);
                    if (result === null || charCheck === null || (charCheck !== null && charCheck.length > 3)) {
                        this.validation.hasError = true;
                        this.validation.errorMessage = 'ShoppingWizard::Template.errorMessageInvalidInitials';
                    } else {
                        this.validation.hasError = false;
                    }
                }
            },
            value: {
                handler(val) {

                    let totalSurcharge = 0.00;
                    let isValid = false;

                    if (this.value.selectedGroupId == this.configuration.groupIdAirbrush) {
                        if (val.selectedAirbrushTypeId !== 0) {
                            totalSurcharge += this.getProperty(val.selectedAirbrushTypeId).property.surcharge;
                        }

                        if (val.selectedAirbrushTypeId == this.configuration.airbrush.airbrushTypeIdLetter &&
                            val.initials !== '' &&
                            !this.validation.hasError) {
                            isValid = true;
                        }

                        if (val.selectedAirbrushTypeId == this.configuration.airbrush.airbrushTypeIdMotive &&
                            val.selectedMotiveSelectionId !== 0) {
                            isValid = true;
                        }

                        if (this.hasProperty(this.configuration.airbrush.airbrushTypeIdColor) && val.selectedColorSelectionId == 0) {
                            isValid = false;
                        }

                    } else {

                        if (val.selectedBrandingTypeId !== 0) {
                            let positionKey = this.getBrandingPositionKey();
                            if (val.selectedBrandingTypeId == this.configuration.productBranding.brandingTypeIdDefault &&
                                this.configuration.productBranding.positions[positionKey].defaultImage != "") {
                                this.$emit('set-preview-img', this.configuration.productBranding.positions[positionKey].defaultImage);
                            } else if (val.selectedBrandingTypeId == this.configuration.productBranding.brandingTypeIdSilver &&
                                this.configuration.productBranding.positions[positionKey].silverImage != "") {
                                this.$emit('set-preview-img', this.configuration.productBranding.positions[positionKey].silverImage);
                            } else if (val.selectedBrandingTypeId == this.configuration.productBranding.brandingTypeIdGold &&
                                this.configuration.productBranding.positions[positionKey].goldImage != "") {
                                this.$emit('set-preview-img', this.configuration.productBranding.positions[positionKey].goldImage);
                            } else {
                                this.$emit('set-preview-img', null);
                            }


                            totalSurcharge += this.getProperty(val.selectedBrandingTypeId).property.surcharge;
                        }

                        if (val.selectedBrandingTypeId !== 0 &&
                            val.initials !== '' &&
                            !this.validation.hasError) {
                            isValid = true;
                        }
                    }

                    this.$emit('update-surcharge', totalSurcharge);
                    this.$emit('is-valid', isValid);
                    this.$emit('input', val);
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

    .nav-link {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .colors,
    .motive {
        opacity: .3;
        padding-left: 5px;
        padding-right: 5px;
        cursor: pointer;
    }

    .colors.active,
    .motive.active {
        opacity: 1;
    }

    .motive img {
        max-height: 50px;
        vertical-align: middle;
    }

    .colors img {
        max-height: 30px;
        vertical-align: middle;
        border: 1px solid #333;
    }

    .branding.row{
        margin-left: -5px;
        margin-right: -5px;
    }

    .branding.row .col-lg-4{
        padding-left: 5px;
        padding-right: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/ShoppingWizardProperties.vue